export const removeEmpty = obj => {
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object') {
      removeEmpty(obj[key]);
    } else if (obj[key] === null || typeof obj[key] === 'undefined') {
      delete obj[key];
    }
  });

  return obj;
};
